import { AxiosRequestConfig } from 'axios';
import { emeraldRequest } from '../../../common/api/emerald-request';
import { TenderPaymentOptions } from '../../../common/interfaces/dtos/ITender';
import { EmeraldRequestParams } from '../../../common/interfaces/requests/EmeraldRequestParams';

export const getTenderPaymentOptions = async (tenderId?: string): Promise<TenderPaymentOptions> => {
  const axiosConfig: AxiosRequestConfig = {
    method: 'GET',
    url: `/menu/tenders/${tenderId}/payment-options`,
  };
  const emeraldRequestParams: EmeraldRequestParams = {
    config: axiosConfig,
    addPOSMetaData: true,
    showLoadingComponent: false,
    showLoggingInfo: true,
    spanOptions: { name: 'Checkout - Payment Options' },
  };
  return emeraldRequest<TenderPaymentOptions>(emeraldRequestParams);
};
